import type { JSX } from 'preact';
import {
  ArrowRight,
  BarChart3,
  ExternalLink,
  FileText,
  House,
  Image,
  QrCode,
  Search,
  Settings,
  type LucideIcon,
} from 'lucide-preact';

export type PlatformIconName = 'home' | 'qr' | 'form' | 'data' | 'settings' | 'external' | 'search' | 'redirect' | 'image';

const icons: Record<PlatformIconName, LucideIcon> = {
  home: House,
  qr: QrCode,
  form: FileText,
  data: BarChart3,
  settings: Settings,
  external: ExternalLink,
  search: Search,
  redirect: ArrowRight,
  image: Image,
};

export function Icon({ name, size = 20, className }: { name: PlatformIconName; size?: number; className?: string }): JSX.Element {
  const Component = icons[name];
  return <Component className={className} size={size} aria-hidden="true" focusable="false" strokeWidth={2} />;
}
